import clsx from "clsx";

import { NoData, RenderWhen, TooltipIcon } from "@components";
import Typography from "@js2/components/typography/Typography";
import { NetworkRepEntry } from "@modules/network/@types/Url";
import styles from "./network-references.module.scss";

type Props = {
  networkRepEntry: NetworkRepEntry;
};

export const NetworkReferenceReputationGridTitle = () => (
  <div className="flex flex-center flex-gap-2">
    <Typography variant="subtitle7">Reputation</Typography>
    <TooltipIcon
      icon="info-circle"
      message="Displaying 3rd party reputation info, and a malware icon for sources of malicious samples"
      className={styles.info_icon}
    />
  </div>
);

const NetworkReferenceReputation = ({ networkRepEntry }: Props) => (
  <div
    className={clsx(
      styles.reputation_col,
      styles[networkRepEntry.classification]
    )}
  >
    <RenderWhen
      condition={networkRepEntry.third_party_reputations?.total > 0}
      fallback={<NoData />}
    >
      {networkRepEntry.third_party_reputations?.malicious ?? 0}/
      {networkRepEntry.third_party_reputations?.total ?? 0}
    </RenderWhen>
    {networkRepEntry.associated_malware && (
      <TooltipIcon
        icon="malware"
        message="This network reference has been associated with malicious samples by ReversingLabs"
      />
    )}
  </div>
);

export default NetworkReferenceReputation;
